module.exports = __webpack_public_path__ + "img/RY_1000_R.6433c276.png";